import { useSelector } from "react-redux";
import { Box, Typography } from "@material-ui/core";

import { Table } from "../table";
import { currencyFormatter } from "../../services";
import { NoTableData } from "./noTableData";

const cellStyle = { padding: "18px 0 18px 32px" };

export const ProfitabilityComponents = ({ title, tableHeader, tableBody }) => {
  const { user } = useSelector((state) => state.auth);
  const currencySymbol = user.currency.symbol;

  return (
    <Box>
      <Typography variant="h4" style={{ marginBottom: 14, marginTop: 24 }}>
        {title}
      </Typography>
      {!user.is_demo || !tableBody.length ? (
        <NoTableData title="No data available" />
      ) : (
        <Table
          headers={tableHeader}
          data={tableBody.map((item, i) =>
            [
              item.type,
              currencyFormatter(item.monthly, currencySymbol),
              currencyFormatter(item.yearly, currencySymbol),
              `${currencyFormatter(item.yearly_square, currencySymbol)}/${user.unit_system}`,
              `${currencyFormatter(item.portfolio, currencySymbol)}/${user.unit_system}`,
              `${currencyFormatter(item.industry, currencySymbol)}/${user.unit_system}`,
            ].map((value) => (
              <Typography style={{ fontWeight: [7, 13].includes(i) ? 700 : 400 }} key={i}>
                {value}
              </Typography>
            ))
          )}
          colWidths={[25, 15, 15, 15, 15, 15]}
          cellStyles={Array.from({ length: 6 }, () => cellStyle)}
          maxHeight={616}
          rowStyles={tableBody.map((row) => row?.rowStyles)}
        />
      )}
    </Box>
  );
};
